import { Thumbnail } from '@platform/design-system';
import { nameIn } from './categories.ts';
import { coverOf, type Product } from './product.ts';
import styles from './ProductName.module.css';

export const ProductName = ({
  product,
  locale,
  meta = null,
}: {
  product: Product;
  locale: string;
  meta?: string | null;
}) => {
  const name = nameIn(product, locale, product.id);
  const cover = coverOf(product);
  return (
    <span className={styles['name']}>
      <Thumbnail src={cover?.urls.w320 ?? null} placeholder={cover?.placeholder ?? null} alt="" size="sm" />
      <span className={styles['text']}>
        <span className={styles['title']}>{name}</span>
        {meta === null ? null : <span className={styles['meta']}>{meta}</span>}
      </span>
    </span>
  );
};
